import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { RequestComponent } from './components/features/request/request';
import { RequestService } from './services/request';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RequestComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title = 'MyImport';
  langDirection = 'mc-rtl-lang';
  currentUrl: string = "";
  isNeedProgress: boolean = false;

  constructor(
    private translateService: TranslateService
    , private requestService: RequestService) {
  }




  ngOnInit() {
    this.translate()
    this.setFromState();
  }

  setFromState() {
    this.requestService.initMyImportFormState()
  }


  // initLanguage() {
  //   this.subscription.add(
  //     this.rootStoreService.getLanguage().subscribe((lang: Language) => {

  //       if (lang === Language.HE) {
  //         this.langDirection = 'is-rtl-lang'

  //       }
  //       else {
  //         this.langDirection = 'is-ltr-lang'
  //       }
  //       //document.body.className = this.langDirection;
  //       //document.documentElement.dir
  //       //document.documentElement.lang
  //       this.translate();
  //     }))
  // }
  // translate() {
  //   const langTranslate = this.languageService.getTranslateLanguage();

  //   this.translateService.use(langTranslate);
  //   this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
  // }
  translate() {
    const langTranslate = 'he';//this.languageService.getTranslateLanguage();
    this.translateService.use(langTranslate);
    // this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
  }
}
